import { call, all, put, takeLatest } from 'redux-saga/effects';
import notification from '../../../services/notification';
import api from '../../../services/api';
import types from '../../types';

function* getLimitations() {
  try {
    const { status, data } = yield call(api.market.limitation.getLimitations);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_LIMITATIONS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_LIMITATIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateLimitations({ payload }) {
  try {
    const { status, data } = yield call(
      api.market.limitation.updateLimitations,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_LIMITATIONS_SUCCESS, payload: data });
    yield put({ type: types.GET_LIMITATIONS_START });
  } catch (error) {
    yield put({ type: types.UPDATE_LIMITATIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* limitations() {
  yield all([
    takeLatest(types.GET_LIMITATIONS_START, getLimitations),
    takeLatest(types.UPDATE_LIMITATIONS_START, updateLimitations),
  ]);
}
